// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VS35","colBig":"styles_colBig__1jTQ2","colSmall":"styles_colSmall__NHexd"};